import { t, Trans } from "@lingui/macro";
import { Modal } from "antd";
import React from "react";
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';

// Show the confirmation modal due to missing MULTI/MANAGE subscriptions, eg UOM, tags etc.
// Promise is used to make the Modal.warning synchronous
export function showConfirmationModalPromise(nonBaseUomItems, removedBundles, changes) {
    const {
        hasTaxChange,
        hasLocationChange,
        hasTagChange,
        hasCurrencyCodeChange,
        hasFieldChange,
    } = changes;

    // console.log('aaa removedBundles, changes', {removedBundles, changes});

    const allChanges = [];

    if (hasTagChange) {
        allChanges.push(
            <Trans>All tags will be removed.</Trans>,
        );
    }
    if (hasCurrencyCodeChange) {
        allChanges.push(
            <Trans><strong>Currency will be reverted to the company&apos;s currency.</strong></Trans>,
        );
    }
    if (hasLocationChange) {
        allChanges.push(
            <Trans>All product locations will be reverted to the default inventory location.</Trans>,
        );
    }
    if (hasTaxChange) {
        allChanges.push(
            <Trans>All tax applied on products will be removed.</Trans>,
        );
    }

    // Removed Bundle
    if (removedBundles?.length && removedBundles.length !== 0) {
        // const removedBundleItems = removedBundles.map(i => i.product_name);
        allChanges.push(
            <Trans>All product bundles will be removed.</Trans>,
        );
    }

    // Removed items with non-default UOM
    if (nonBaseUomItems?.length && nonBaseUomItems.length !== 0) {
        const invalidUoms = Array.from(new Set(nonBaseUomItems.map(i => i.product_unit_label)));
        allChanges.push(
            <>
                <Trans>Lines with the following UOMs will be removed:</Trans>
                <ul className="ul__circle secondary">
                    {invalidUoms.map(uom => <li key={uom}>{uom}</li>)}
                </ul>
            </>,
        );
    }
    if (hasFieldChange) {
        allChanges.push(
            <Trans>All custom field values will be removed.</Trans>,
        );
    }

    return new Promise(resolve => {
        Modal.warning({
            title: t`Unsupported Features`,
            content: (
                <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                    {/* {
                            t`This transaction contains non-base UOM items, which are not included in your subscription plan.`
                        } */}
                    <Trans>
                        This transaction contains features not supported in your current subscription.
                        Please review fallback changes that will be applied to the transaction.
                    </Trans>
                    <br />
                    <br />
                    <strong>
                        <Trans>Unsupported Features:</Trans>
                    </strong>
                    <ul className="ul__disc">
                        {allChanges.map(change => <li key={Math.random()}>{change}</li>)}
                    </ul>

                </I18nProvider>
            ),
            onOk: () => {
                resolve(); // Resolve the Promise on OK
            },
            keyboard: false, // prevent closing the modal using Esc key
            // onCancel: () => {
            //     reject(); // Reject the Promise on Cancel
            // },
        });
    });
}
